const reasons = [
  {
    icon: 'ri-building-2-line',
    title: 'Ambiente profissional e colaborativo',
    description: 'Trabalhe em uma empresa com cultura de respeito, parceria e união entre todos os colaboradores.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Oportunidade de crescimento',
    description: 'Plano de carreira estruturado com possibilidades reais de evolução profissional e salarial.',
  },
  {
    icon: 'ri-settings-6-line',
    title: 'Projetos industriais de grande porte',
    description: 'Participe de manutenções, paradas gerais e intervenções em grandes plantas industriais.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Cultura voltada para segurança e qualidade',
    description: 'Segurança do trabalho em primeiro lugar, com treinamentos constantes e equipamentos de proteção.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Desenvolvimento técnico contínuo',
    description: 'Capacitações constantes para aprimorar habilidades e acompanhar as novas tecnologias do setor.',
  },
];

export default function PorqueSection() {
  return (
    <section id="porque" className="relative bg-gp-graphite py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
            <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Vantagens</span>
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white uppercase tracking-wider">
            Por que Trabalhar na <span className="text-gp-yellow">Pilar</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-gp-graphite-light border border-gp-graphite-lighter hover:border-gp-yellow/40 rounded-lg p-6 md:p-8 transition-all duration-300 hover:bg-gp-graphite-lighter/30"
            >
              <div className="w-14 h-14 bg-gp-yellow/10 rounded-lg flex items-center justify-center mb-5 group-hover:bg-gp-yellow/20 transition-colors duration-300">
                <i className={`${reason.icon} text-gp-yellow text-xl w-7 h-7 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-white font-semibold text-base md:text-lg uppercase tracking-wider mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}